import React, { Component } from "react";
import { Tooltip } from "@mui/material";
import { withStyles } from "@mui/styles";
import styles from "./box-layout.styles";
import BOX_TYPE from "../enum/box_type";
import "./index.css";
import { withTranslation } from "react-i18next";
import groupTypes from "../common/group-types";
import LockIcon from "@mui/icons-material/Lock";

let nums1 = Array.from(Array(12).keys());
let nums3 = Array.from(Array(3).keys());
let BinIds = [];
let deactivatedBin = [];
let IsSaved;

export class C30Layout extends Component {
  handleChangeIndex = (index) => {
    this.setState({
      selectedUnit: index,
    });
    this.props.getSelectedUnitName(index);
  };

  componentWillReceiveProps() {
    const { deactivatedBins } = this.props;
    if (deactivatedBins && deactivatedBins.length > 0) {
      deactivatedBins.map((item) => {
        if (item) {
          deactivatedBin.push(item);
          let node = document.getElementById(item);
          if (node !== null && node !== undefined) {
            let x = node.parentNode.classList && node.parentNode.classList[2];
            node.parentNode.classList.remove(x);
            let items = document.getElementById(item);
            if (items && items.style) {
              items.style.background =
                "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)";
              items.style.color = "#fff";
              items.style.cursor = "pointer";
            }
          }
        }
        return true;
      });
    } else {
      deactivatedBin.map((item) => {
        if (item) {
          var items = document.getElementById(item);
          if (items && items.style) {
            items.style.background =
              "linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)";
            items.style.color = "#000";
            items.style.cursor = "pointer";
            items.style.pointerEvents = "all";
          }
        }
        return true;
      });
      deactivatedBin = [];
    }
  }

  checkIsSaved = (binId) => {
    if (this.props && this.props.BinStatus.length > 0) {
      this.props.BinStatus.map((binitem) => {
        if (binitem.bin_id === binId) {
          IsSaved = true;
        } else {
          IsSaved = false;
        }
        return true;
      });
    } else {
      IsSaved = false;
    }
  };
  openbin = (binId, status, pm_id) => {
    if (status === "Assigned" || status === "Stocked" || status === "Hold") {
      if (this.props.deactivatedBins.includes(binId)) {
        this.props.Selectedbin(binId, this.props.box_position);
        let items = document.getElementById(binId);
        items.style.background =
          "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)"; // deavtivated
        items.style.color = "#ffffff";
      }
      this.props.getPrescriptionDetails(binId, pm_id);
    } else {
      BinIds.map((item) => {
        this.checkIsSaved(item);
        if (item !== binId && IsSaved === false) {
          var items = document.getElementById(item);
          items.style.background =
            "linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)";
        }
        return true;
      });
      BinIds = [];
      BinIds.push(binId);
      if (BinIds.length > 0) {
        this.props.Selectedbin(binId, this.props.box_position);
        var items = document.getElementById(binId);
        items.style.background =
          "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(253, 253, 2) 90%)";
      }
    }
  };

  getColumns = (
    currentIndex,
    currentColumnCount,
    previousColumnCount,
    side
  ) => {
    let columns = [];
    if (side === "L") {
      for (
        let i = previousColumnCount + currentColumnCount;
        i > previousColumnCount;
        i--
      ) {
        columns.push(
          String.fromCharCode(65 + (i - 1)) + String.fromCharCode(65 + (i - 1))
        );
      }
    } else {
      for (
        let i = previousColumnCount;
        i < previousColumnCount + currentColumnCount;
        i++
      ) {
        columns.push(String.fromCharCode(65 + (i - 1)));
      }
    }
    return columns;
  };

  getCurrentAndPreviousPosition = (side) => {
    const { expansion, ExpansionsCounts, boxTypeId } = this.props;
    let response = {};
    response.currentCount = expansion.bin_column_count;
    if (side === "L") {
      let _expansionsCount =
        ExpansionsCounts && ExpansionsCounts.leftExpansions;
      if (expansion.box_position === -1 || expansion.box_position === "-1") {
        response.previousCount = 0;
      } else {
        response.previousCount = this.excludeCurrentExpansion(
          expansion,
          _expansionsCount
        );
      }
    } else {
      let _expansionsCount = ExpansionsCounts.rightExpansions;
      if (expansion.box_position === 1 || expansion.box_position === "1") {
        if (boxTypeId === BOX_TYPE.Locker) {
          response.previousCount = 6;
        } else {
          response.previousCount = 4;
        }
      } else {
        if (boxTypeId === BOX_TYPE.Locker) {
          response.previousCount =
            this.excludeCurrentExpansion(expansion, _expansionsCount) + 6;
        } else {
          response.previousCount =
            this.excludeCurrentExpansion(expansion, _expansionsCount) + 4;
        }
      }
    }
    return response;
  };

  excludeCurrentExpansion = (expansion, expansionArray) => {
    let currentUnitIndex = null;
    let sumOfColumns = 0;
    for (let index = 0; index < expansionArray.length; index++) {
      if (expansionArray[index].expansionId === expansion.id) {
        currentUnitIndex = index;
        break;
      }
    }
    for (let i = 0; i < currentUnitIndex; i++) {
      if (expansionArray[i - 1] !== undefined) {
        sumOfColumns =
          expansionArray[i].bin_column_count +
          expansionArray[i - 1].bin_column_count;
      } else {
        sumOfColumns = expansionArray[i].bin_column_count;
      }
    }
    return sumOfColumns;
  };

  isRestricted = (groupTypeId) => {
    return [
      groupTypes.Retail,
      groupTypes.Super,
      groupTypes.eCommerce,
      groupTypes.Audiology,
    ].includes(groupTypeId)
      ? true
      : false;
  };

  renderCell = (
    BinStatus,
    binType,
    binKey,
    pm_id,
    statusClass,
    statusTitle
  ) => {
    const { isViewPermissionAllowed } = this.props;
    return (
      <td
        style={{
          padding: "4px",
          width: "85px",
          pointerEvents: this.isRestricted(
            BinStatus && BinStatus.group_type_id
          )
            ? "none"
            : isViewPermissionAllowed
            ? "auto"
            : "none",
          cursor: this.isRestricted(BinStatus && BinStatus.group_type_id)
            ? "not-allowed"
            : isViewPermissionAllowed
            ? "pointer"
            : "not-allowed",
        }}
        onClick={() => this.openbin(binKey, binType, pm_id)}
      >
        <Tooltip key={binKey} title={statusTitle}>
          <div
            id={binKey}
            className={statusClass}
          >
            {this.isRestricted(BinStatus && BinStatus.group_type_id) && (
              <LockIcon fontSize="12px" />
            )}
            &nbsp;{binKey}
          </div>
        </Tooltip>
      </td>
    );
  };

  renderMiddleColumnCells = (
    n,
    n1,
    elem3,
    BinStatus,
    binType,
    binKey,
    pm_id,
    statusClass,
    statusTitle
  ) => {
    const { isViewPermissionAllowed } = this.props;
    if (n === 1 && n1 === 0) {
      return (
        <td
          rowSpan={2}
          style={{
            padding: "4px",
            width: "85px",
            height: "90px",
            pointerEvents: this.isRestricted(
              BinStatus && BinStatus.group_type_id
            )
              ? "none"
              : isViewPermissionAllowed
              ? "auto"
              : "none",
            cursor: this.isRestricted(BinStatus && BinStatus.group_type_id)
              ? "not-allowed"
              : isViewPermissionAllowed
              ? "pointer"
              : "not-allowed",
          }}
          onClick={() => this.openbin(elem3[n] + "" + (n1 + 1), binType, pm_id)}
        >
          <Tooltip key={elem3[n] + "" + (n1 + 1)} title={statusTitle}>
            <div
              id={elem3[n] + "" + (n1 + 1)}
              className={statusClass}
              style={{
                height: "90px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{elem3[n] + "" + (n1 + 1)}
            </div>
          </Tooltip>
        </td>
      );
    }
    if (n === 1 && n1 === 2) {
      return (
        <td
          rowSpan={2}
          style={{
            padding: "4px",
            width: "85px",
            height: "90px",
            pointerEvents: this.isRestricted(
              BinStatus && BinStatus.group_type_id
            )
              ? "none"
              : isViewPermissionAllowed
              ? "auto"
              : "none",
            cursor: this.isRestricted(BinStatus && BinStatus.group_type_id)
              ? "not-allowed"
              : isViewPermissionAllowed
              ? "pointer"
              : "not-allowed",
          }}
          onClick={() => this.openbin(elem3[n] + "" + n1, binType, pm_id)}
        >
          <Tooltip key={elem3[n] + "" + n1} title={statusTitle}>
            <div
              id={elem3[n] + "" + n1}
              className={statusClass}
              style={{
                height: "90px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{elem3[n] + "" + n1}
            </div>
          </Tooltip>
        </td>
      );
    }
    if (n === 1 && [4, 5].includes(n1)) {
      return (
        <td
          style={{
            padding: "4px",
            width: "85px",
            pointerEvents: this.isRestricted(
              BinStatus && BinStatus.group_type_id
            )
              ? "none"
              : isViewPermissionAllowed
              ? "auto"
              : "none",
            cursor: this.isRestricted(BinStatus && BinStatus.group_type_id)
              ? "not-allowed"
              : isViewPermissionAllowed
              ? "pointer"
              : "not-allowed",
          }}
          onClick={() => this.openbin(elem3[n] + "" + (n1 - 1), binType, pm_id)}
        >
          <Tooltip key={elem3[n] + "" + (n1 - 1)} title={statusTitle}>
            <div
              id={elem3[n] + "" + (n1 - 1)}
              className={statusClass}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{elem3[n] + "" + (n1 - 1)}
            </div>
          </Tooltip>
        </td>
      );
    }
    if (n === 1 && n1 === 6) {
      return (
        <td
          rowSpan={3}
          style={{
            padding: "4px",
            width: "85px",
            height: "140px",
            pointerEvents: this.isRestricted(
              BinStatus && BinStatus.group_type_id
            )
              ? "none"
              : isViewPermissionAllowed
              ? "auto"
              : "none",
            cursor: this.isRestricted(BinStatus && BinStatus.group_type_id)
              ? "not-allowed"
              : isViewPermissionAllowed
              ? "pointer"
              : "not-allowed",
          }}
          onClick={() => this.openbin(elem3[n] + "" + (n1 - 1), binType, pm_id)}
        >
          <Tooltip key={elem3[n] + "" + (n1 - 1)} title={statusTitle}>
            <div
              id={elem3[n] + "" + (n1 - 1)}
              className={statusClass}
              style={{
                height: "140px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{elem3[n] + "" + (n1 - 1)}
            </div>
          </Tooltip>
        </td>
      );
    }
    if (n === 1 && n1 === 9) {
      return (
        <td
          rowSpan={3}
          style={{
            padding: "4px",
            width: "85px",
            height: "140px",
            pointerEvents: this.isRestricted(
              BinStatus && BinStatus.group_type_id
            )
              ? "none"
              : isViewPermissionAllowed
              ? "auto"
              : "none",
            cursor: this.isRestricted(BinStatus && BinStatus.group_type_id)
              ? "not-allowed"
              : isViewPermissionAllowed
              ? "pointer"
              : "not-allowed",
          }}
          onClick={() => this.openbin(elem3[n] + "" + (n1 - 3), binType, pm_id)}
        >
          <Tooltip key={elem3[n] + "" + (n1 - 3)} title={statusTitle}>
            <div
              id={elem3[n] + "" + (n1 - 3)}
              className={statusClass}
              style={{
                height: "140px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{elem3[n] + "" + (n1 - 3)}
            </div>
          </Tooltip>
        </td>
      );
    } else {
      return (
        n !== 1 &&
        n1 !== 1 && (
          <td
            style={{
              padding: "4px",
              width: "85px",
              pointerEvents: this.isRestricted(
                BinStatus && BinStatus.group_type_id
              )
                ? "none"
                : isViewPermissionAllowed
                ? "auto"
                : "none",
              cursor: this.isRestricted(
                BinStatus && BinStatus.group_type_id
              )
                ? "not-allowed"
                : isViewPermissionAllowed
                ? "pointer"
                : "not-allowed",
            }}
            onClick={() => this.openbin(binKey, binType, pm_id)}
          >
            <Tooltip key={binKey} title={statusTitle}>
              <div
                id={elem3[n] + "" + (n1 + 1)}
                className={statusClass}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {this.isRestricted(BinStatus && BinStatus.group_type_id) && (
                  <LockIcon fontSize="12px" />
                )}
                &nbsp;{elem3[n] + "" + n1}
              </div>
            </Tooltip>
          </td>
        )
      );
    }
  };

  getBinIndexForMiddleColumn = (n, n1, elem3) => {
    let index = null;
    if (n === 1 && n1 === 0) {
      index = elem3[n] + "" + (n1 + 1);
    } else if (n === 1 && n1 === 2) {
      index = elem3[n] + "" + n1;
    } else if (n === 1 && [4, 5].includes(n1)) {
      index = elem3[n] + "" + (n1 - 1);
    } else if (n === 1 && n1 === 6) {
      index = elem3[n] + "" + (n1 - 1);
    } else if (n === 1 && n1 === 9) {
      index = elem3[n] + "" + (n1 - 3);
    } else {
      index =  n === 1 ? (elem3[n] + "" + n1) : (elem3[n] + "" + (n1 + 1));
    }
    return index;
  };

  render() {
    const BoxStatus = {
      ASSIGNED: "8f9c8e02-b9ee-4f29-aeea-670cef022663",
      STOCKED: "4ee90c0f-d4c3-4d53-8014-d7eac4ea2894",
      HOLD: "45593c2c-fc8c-4bf0-854e-e2bf759b7788",
      PICKED_UP: "00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e",
      CANCELLED: "8a994741-402e-4b18-a883-60da7fc94c7b",
      RETURNED: "198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55",
      DEACTIVATED: "4f666da5-bfe0-4fb5-ad77-b92103881220",
    };
    // eslint-disable-next-line
    const {
      classes,
      BinStatus,
      box_position,
      deactivatedBins,
      isViewPermissionAllowed,
      t,
    } = this.props;
    let elem3 = [];
    let side = box_position < 0 ? "L" : "R";
    if (side === "L") {
      let prevNextCount = this.getCurrentAndPreviousPosition(side);
      let previousExpansionCount =
        prevNextCount && prevNextCount.previousCount
          ? prevNextCount.previousCount
          : 0;
      elem3 = this.getColumns(
        box_position,
        prevNextCount && prevNextCount.currentCount,
        previousExpansionCount,
        side
      );
    } else {
      let prevNextCount = this.getCurrentAndPreviousPosition(side);
      let previousExpansionCount =
        prevNextCount && prevNextCount.previousCount
          ? prevNextCount.previousCount
          : 0;
      elem3 = this.getColumns(
        box_position,
        prevNextCount && prevNextCount.currentCount,
        previousExpansionCount,
        side
      );
    }
    return (
      <div key={this.props.prefix}>
        <div
          className={classes.ratingContainer}
          style={{
            marginBottom: "3px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <table
            style={{
              pointerEvents: isViewPermissionAllowed ? "auto" : "none",
            }}
          >
            {nums1.map((n1) => {
              return (
                <tr>
                  {nums3.map((n) => {
                    if (n !== 1) {
                      if (
                        BinStatus &&
                        BinStatus.length &&
                        BinStatus.length > 0
                      ) {
                        let binKey = this.getBinIndexForMiddleColumn(n, n1, elem3);
                        for (var i = 0; i < BinStatus.length; i++) {
                          let pm_id = BinStatus[i].id;
                          let bin_id = BinStatus[i].bin_id;
                          let type_id = BinStatus[i].type_id;
                          if (bin_id === binKey) {
                            if (type_id === BoxStatus.STOCKED) {
                              return this.renderCell(
                                BinStatus[i],
                                "Stocked",
                                binKey,
                                pm_id,
                                classes.gridOrangeback,
                                t("Global.Prescriptions.Status.Stocked")
                              );
                            }
                            if (type_id === BoxStatus.ASSIGNED) {
                              return this.renderCell(
                                BinStatus[i],
                                "Assigned",
                                binKey,
                                pm_id,
                                classes.gridBlueback,
                                t("Global.Prescriptions.Status.Assigned")
                              );
                            }
                            if (type_id === BoxStatus.HOLD) {
                              return this.renderCell(
                                BinStatus[i],
                                "Hold",
                                binKey,
                                pm_id,
                                classes.gridSkyblueback,
                                t("Global.Prescriptions.Status.Hold")
                              );
                            }
                          }
                        }
                        if (
                          deactivatedBins &&
                          deactivatedBins.length &&
                          deactivatedBins.length > 0 &&
                          deactivatedBins.findIndex(
                            (D) => D === elem3[n] + (n1 + 1)
                          ) > -1
                        ) {
                          return (
                            <td
                              style={{
                                padding: "4px",
                                width: "85px",
                                pointerEvents: this.isRestricted(
                                  BinStatus[i] && BinStatus[i].group_type_id
                                )
                                  ? "none"
                                  : isViewPermissionAllowed
                                  ? "auto"
                                  : "none",
                                cursor: this.isRestricted(
                                  BinStatus[i] && BinStatus[i].group_type_id
                                )
                                  ? "not-allowed"
                                  : isViewPermissionAllowed
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                            >
                              <Tooltip key={binKey} title="DEACTIVATE">
                                <div
                                  id={binKey}
                                  className={classes.gridRedback}
                                >
                                  {this.isRestricted(
                                    BinStatus[i] && BinStatus[i].group_type_id
                                  ) && <LockIcon fontSize="12px" />}
                                  &nbsp;{binKey}
                                </div>
                              </Tooltip>
                            </td>
                          );
                        }
                        return this.renderCell(
                          BinStatus[i],
                          "Available",
                          binKey,
                          null,
                          classes.gridback,
                          t("Global.Prescriptions.Status.Available")
                        );
                      }
                    } else {
                      if (
                        BinStatus &&
                        BinStatus.length &&
                        BinStatus.length > 0
                      ) {
                        let binKey = this.getBinIndexForMiddleColumn(n, n1, elem3);
                        for (var j = 0; j < BinStatus.length; j++) {
                          let pm_id = BinStatus[j].id;
                          let bin_id = BinStatus[j].bin_id;
                          let type_id = BinStatus[j].type_id;
                          if (bin_id === binKey) {
                            if (type_id === BoxStatus.STOCKED) {
                              return this.renderMiddleColumnCells(
                                n,
                                n1,
                                elem3,
                                BinStatus[j],
                                "Stocked",
                                binKey,
                                pm_id,
                                classes.gridOrangeback,
                                t("Global.Prescriptions.Status.Stocked")
                              );
                            }
                            if (type_id === BoxStatus.ASSIGNED) {
                              return this.renderMiddleColumnCells(
                                n,
                                n1,
                                elem3,
                                BinStatus[j],
                                "Assigned",
                                binKey,
                                pm_id,
                                classes.gridBlueback,
                                t("Global.Prescriptions.Status.Assigned")
                              );
                            }
                            if (type_id === BoxStatus.HOLD) {
                              return this.renderMiddleColumnCells(
                                n,
                                n1,
                                elem3,
                                BinStatus[j],
                                "Hold",
                                binKey,
                                pm_id,
                                classes.gridSkyblueback,
                                t("Global.Prescriptions.Status.Hold")
                              );
                            }
                          }
                        }
                        if (
                          deactivatedBins &&
                          deactivatedBins.length &&
                          deactivatedBins.length > 0 &&
                          deactivatedBins.findIndex(
                            (D) =>
                              D ===
                              this.getBinIndexForMiddleColumn(n, n1, elem3)
                          ) > -1
                        ) {
                          if (n === 1 && n1 === 0) {
                            return (
                              <td
                                rowSpan={2}
                                style={{
                                  padding: "4px",
                                  width: "85px",
                                  height: "90px",
                                  pointerEvents: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "none"
                                    : isViewPermissionAllowed
                                    ? "auto"
                                    : "none",
                                  cursor: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "not-allowed"
                                    : isViewPermissionAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                              >
                                <Tooltip
                                  key={elem3[n] + "" + (n1 + 1)}
                                  title={"DEACTIVATE"}
                                >
                                  <div
                                    id={elem3[n] + "" + (n1 + 1)}
                                    className={classes.gridRedback}
                                    style={{
                                      height: "90px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {this.isRestricted(
                                      BinStatus[j] && BinStatus[j].group_type_id
                                    ) && <LockIcon fontSize="12px" />}
                                    &nbsp;{elem3[n] + "" + (n1 + 1)}
                                  </div>
                                </Tooltip>
                              </td>
                            );
                          }
                          if (n === 1 && n1 === 2) {
                            return (
                              <td
                                rowSpan={2}
                                style={{
                                  padding: "4px",
                                  width: "85px",
                                  height: "90px",
                                  pointerEvents: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "none"
                                    : isViewPermissionAllowed
                                    ? "auto"
                                    : "none",
                                  cursor: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "not-allowed"
                                    : isViewPermissionAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                              >
                                <Tooltip
                                  key={elem3[n] + "" + n1}
                                  title={"DEACTIVATE"}
                                >
                                  <div
                                    id={elem3[n] + "" + n1}
                                    className={classes.gridRedback}
                                    style={{
                                      height: "90px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {this.isRestricted(
                                      BinStatus[j] && BinStatus[j].group_type_id
                                    ) && <LockIcon fontSize="12px" />}
                                    &nbsp;{elem3[n] + "" + n1}
                                  </div>
                                </Tooltip>
                              </td>
                            );
                          }
                          if (n === 1 && [4, 5].includes(n1)) {
                            return (
                              <td
                                style={{
                                  padding: "4px",
                                  width: "85px",
                                  pointerEvents: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "none"
                                    : isViewPermissionAllowed
                                    ? "auto"
                                    : "none",
                                  cursor: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "not-allowed"
                                    : isViewPermissionAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                              >
                                <Tooltip
                                  key={elem3[n] + "" + (n1 - 1)}
                                  title={"DEACTIVATE"}
                                >
                                  <div
                                    id={elem3[n] + "" + (n1 - 1)}
                                    className={classes.gridRedback}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {this.isRestricted(
                                      BinStatus[j] && BinStatus[j].group_type_id
                                    ) && <LockIcon fontSize="12px" />}
                                    &nbsp;{elem3[n] + "" + (n1 - 1)}
                                  </div>
                                </Tooltip>
                              </td>
                            );
                          }
                          if (n === 1 && n1 === 6) {
                            return (
                              <td
                                rowSpan={3}
                                style={{
                                  padding: "4px",
                                  width: "85px",
                                  height: "140px",
                                  pointerEvents: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "none"
                                    : isViewPermissionAllowed
                                    ? "auto"
                                    : "none",
                                  cursor: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "not-allowed"
                                    : isViewPermissionAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                              >
                                <Tooltip
                                  key={elem3[n] + "" + (n1 - 1)}
                                  title={"DEACTIVATE"}
                                >
                                  <div
                                    id={elem3[n] + "" + (n1 - 1)}
                                    className={classes.gridRedback}
                                    style={{
                                      height: "140px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {this.isRestricted(
                                      BinStatus[j] && BinStatus[j].group_type_id
                                    ) && <LockIcon fontSize="12px" />}
                                    &nbsp;{elem3[n] + "" + (n1 - 1)}
                                  </div>
                                </Tooltip>
                              </td>
                            );
                          }
                          if (n === 1 && n1 === 9) {
                            return (
                              <td
                                rowSpan={3}
                                style={{
                                  padding: "4px",
                                  width: "85px",
                                  height: "140px",
                                  pointerEvents: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "none"
                                    : isViewPermissionAllowed
                                    ? "auto"
                                    : "none",
                                  cursor: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "not-allowed"
                                    : isViewPermissionAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                              >
                                <Tooltip
                                  key={elem3[n] + "" + (n1 - 3)}
                                  title={"DEACTIVATE"}
                                >
                                  <div
                                    id={elem3[n] + "" + (n1 - 3)}
                                    className={classes.gridRedback}
                                    style={{
                                      height: "140px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {this.isRestricted(
                                      BinStatus[j] && BinStatus[j].group_type_id
                                    ) && <LockIcon fontSize="12px" />}
                                    &nbsp;{elem3[n] + "" + (n1 - 3)}
                                  </div>
                                </Tooltip>
                              </td>
                            );
                          } else {
                            return (
                              n !== 1 &&
                              n1 !== 1 && (
                                <td
                                  style={{
                                    padding: "4px",
                                    width: "85px",
                                    pointerEvents: this.isRestricted(
                                      BinStatus[j] &&
                                        BinStatus[j].group_type_id
                                    )
                                      ? "none"
                                      : isViewPermissionAllowed
                                      ? "auto"
                                      : "none",
                                    cursor: this.isRestricted(
                                      BinStatus[j] &&
                                        BinStatus[j].group_type_id
                                    )
                                      ? "not-allowed"
                                      : isViewPermissionAllowed
                                      ? "pointer"
                                      : "not-allowed",
                                  }}
                                >
                                  <Tooltip key={binKey} title={"DEACTIVATE"}>
                                    <div
                                      id={elem3[n] + "" + (n1 + 1)}
                                      className={classes.gridRedback}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {this.isRestricted(
                                        BinStatus[j] &&
                                          BinStatus[j].group_type_id
                                      ) && <LockIcon fontSize="12px" />}
                                      &nbsp;{elem3[n] + "" + n1}
                                    </div>
                                  </Tooltip>
                                </td>
                              )
                            );
                          }
                        }
                        return this.renderMiddleColumnCells(
                          n,
                          n1,
                          elem3,
                          BinStatus[i],
                          "Available",
                          binKey,
                          null,
                          classes.gridback,
                          t("Global.Prescriptions.Status.Available")
                        );
                      }
                    }
                    return this.renderMiddleColumnCells(
                      n,
                      n1,
                      elem3,
                      BinStatus[i],
                      "Available",
                      this.getBinIndexForMiddleColumn(
                        n,
                        n1,
                        elem3
                      ),
                      null,
                      classes.gridback,
                      t("Global.Prescriptions.Status.Available")
                    );
                  })}
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(C30Layout));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/C30.layout.js